import { draft } from './draft'
import { plate } from './plate'
import { isDraft, isPlate } from './utils'

const parseContent = (content: unknown) => {
  if (isPlate(content) || isDraft(content)) {
    return content
  }

  if (typeof content !== 'string') {
    return null
  }

  try {
    return JSON.parse(content)
  } catch (_) {
    return null
  }
}

export const serializeWp = (content: unknown) => {
  if (!content) {
    return draft({})
  }

  const parsed = parseContent(content)

  if (isPlate(parsed)) {
    return plate(parsed)
  }
  if (isDraft(parsed)) {
    return draft(parsed)
  }

  return ''
}
